import React, { useState } from "react";
import { DateRangePickers, DateRangePickersData as DateRangePickersDataOriginal } from "./DateRangePickers";


interface SearchFormProps {
  setTitle : (title : string) => void;
  onSearch : (code : string | null, startDate : string | null, endDate : string |null) => void;
}

interface District {
  code : string,
  name : string
}

// constants.ts
const SEOUL_DISTRICTS: District[] = [
  { code: "11010", name: "종로구" },
  { code: "11020", name: "중구" },
  { code: "11030", name: "용산구" },
  { code: "11040", name: "성동구" },
  { code: "11050", name: "광진구" },
  { code: "11060", name: "동대문구" },
  { code: "11070", name: "중랑구" },
  { code: "11080", name: "성북구" },
  { code: "11090", name: "강북구" },
  { code: "11100", name: "도봉구" },
  { code: "11110", name: "노원구" },
  { code: "11120", name: "은평구" },
  { code: "11130", name: "서대문구" },
  { code: "11140", name: "마포구" },
  { code: "11150", name: "양천구" },
  { code: "11160", name: "강서구" },
  { code: "11170", name: "구로구" },
  { code: "11180", name: "금천구" },
  { code: "11190", name: "영등포구" },
  { code: "11200", name: "동작구" },
  { code: "11210", name: "관악구" },
  { code: "11220", name: "서초구" },
  { code: "11230", name: "강남구" },
  { code: "11240", name: "송파구" },
  { code: "11250", name: "강동구" },
];


type DateRangePickersData = DateRangePickersDataOriginal;


export default function SearchForm(props : SearchFormProps) {
  const [ selectedDistrict, setSelectedDistrict ] = useState({
    name : "종로구",
    code : "11010"
  })
  const [sendStartDate, setSendStartDate] = useState<string | null>(null);
  const [sendEndDate, setSendEndDate] = useState<string | null>(null);
  

  // useGetQuery(selectValue, sendStartDate, sendEndDate)
  const handleOnSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();

    props.onSearch(selectedDistrict.code, sendStartDate, sendEndDate)
    props.setTitle(selectedDistrict.name)
  }


  const onDates = ({ endDate, startDate }: DateRangePickersData) => {
    const formattedStartDate = startDate ? new Date(startDate).toISOString().slice(0, 10) : null; // YYYY-MM-DD 
    const formattedEndDate = endDate ? new Date(endDate).toISOString().slice(0, 10) : null;

    setSendStartDate(formattedStartDate);
    setSendEndDate(formattedEndDate);
  };

  // select tag set function
  const handleValue = (e : React.ChangeEvent<HTMLSelectElement>) => {
    const selectOption = e.target.options[e.target.selectedIndex]
    const selectedCode = selectOption.dataset.value as string;
    const selectedValue = selectOption.value;


    setSelectedDistrict({
      code: selectedCode,
      name: selectedValue
    });
  };


  return (
    <>
      <form 
        className="form" 
        onSubmit={handleOnSubmit}>

        <select
          aria-label="서울시 구립도서관 코드 선택 버튼"
          className="search-select"
          value={selectedDistrict.name}
          onChange={(e)=>handleValue(e)}
        >
          {
            SEOUL_DISTRICTS.map((district) => (
              <option
                key={district.code}
                data-value={district.code}
                value={district.name}
              >
                {district.name}
              </option>
            ))
          }
        </select>

        <DateRangePickers
          onDates={onDates}
        />

        <button 
          aria-label="서울시 구립도서관 선택 제출 버튼"
          type="submit"
        >{ }검색</button>
      </form>

    </>
  );
}
